import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageHandler } from 'src/app/util/language-handler';
import { TranslocoService } from '@jsverse/transloco';
import { CreateDocTdRequestDto } from 'src/app/data-transfer/entities/doc-entities/create-doc-td-request';
import { CreateDocPreRequestDto } from 'src/app/data-transfer/entities/doc-entities/create-doc-pre-request-dto';

export interface CreateDocTdDialogData {
  mode: 'doc' | 'td';
  packagingElements: CreateDocPreRequestDto[];
}

@Component({
  selector: 'app-create-doc-td-dialog',
  templateUrl: './create-doc-td-dialog.component.html',
  styleUrls: ['./create-doc-td-dialog.component.scss'],
})
export class CreateDocTdDialogComponent {
  countryCodes: string[] = [];

  form: FormGroup<{
    languageCode: FormControl<string>;
  }>;

  private languageHandler: LanguageHandler;

  constructor(
    private dialogRef: MatDialogRef<CreateDocTdDialogComponent>,
    private fb: FormBuilder,
    private translateService: TranslocoService,
    @Inject(MAT_DIALOG_DATA) public data: CreateDocTdDialogData
  ) {
    this.languageHandler = new LanguageHandler(this.translateService);
    this.countryCodes = this.languageHandler.getLanguageCodes().filter(code => code === 'de' || code === 'gb');
    this.form = this.fb.group({
      languageCode: new FormControl<string>('gb', { nonNullable: true }),
    });
  }

  get isDoc(): boolean {
    return this.data.mode === 'doc';
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onCreate(): void {
    const result: CreateDocTdRequestDto = {
      language: this.form.getRawValue().languageCode === 'gb' ? 'en' : this.form.getRawValue().languageCode,
      packagingElements: this.data.packagingElements,
    };
    this.dialogRef.close({ confirmed: true, ...result });
  }
}
